<template>
	<div>
		<!-- Если это компонент -->
		<component
			v-if="iconImg.component"
			:is="iconImg.component"
			v-bind="iconImg.props"
			class="file-format-icon"
			:style="{ width: width + 'px', height: height + 'px' }"
		/>
	</div>
</template>

<script>
import iconSvgXls from '@/components/Resource/IconsFille/IconSvgXls.vue'
import IconSvgXml from '@/components/Resource/IconsFille/IconSvgXml.vue'
import IconSvgZip from '@/components/Resource/IconsFille/IconSvgZip.vue'
import IconSvgXlsx from '@/components/Resource/IconsFille/IconSvgXlsx.vue'
import IconSvgMp3 from '@/components/Resource/IconsFille/IconSvgMp3.vue'
import IconSvgDoc from '@/components/Resource/IconsFille/IconSvgDoc.vue'
import IconSvgJpg from '@/components/Resource/IconsFille/IconSvgJpg.vue'
import IconSvg7z from '@/components/Resource/IconsFille/IconSvg7z.vue'
import IconSvgJpeg from '@/components/Resource/IconsFille/iconSvgJpeg.vue'
import IconSvgAv from '@/components/Resource/IconsFille/IconSvgAv.vue'
import IconSvgAvi from '@/components/Resource/IconsFille/IconSvgAvi.vue'
import IconSvgBmp from '@/components/Resource/IconsFille/IconSvgBmp.vue'
import IconSvgJs from '@/components/Resource/IconsFille/IconSvgJs.vue'
import IconSvgBzip from '@/components/Resource/IconsFille/IconSvgBzip.vue'
import IconSvgCss from '@/components/Resource/IconsFille/IconSvgCss.vue'
import IconSvgCsv from '@/components/Resource/IconsFille/IconSvgCsv.vue'
import IconSvgDocx from '@/components/Resource/IconsFille/iconSvgDocx.vue'
import IconSvgFlac from '@/components/Resource/IconsFille/IconSvgFlac.vue'
import iconSvgGif from '@/components/Resource/IconsFille/IconSvgGif.vue'
import IconSvgGz from '@/components/Resource/IconsFille/IconSvgGz.vue'
import IconSvgGzip from '@/components/Resource/IconsFille/IconSvgGzip.vue'
import IconSvgHtm from '@/components/Resource/IconsFille/IconSvgHtm.vue'
import IconSvgHtml from '@/components/Resource/IconsFille/IconSvgHtml.vue'
import IconSvgIco from '@/components/Resource/IconsFille/IconSvgIco.vue'
import IconSvgMp4 from '@/components/Resource/IconsFille/IconSvgMp4.vue'
import IconSvgMpeg from '@/components/Resource/IconsFille/IconSvgMpeg.vue'
import IconSvgJson from '@/components/Resource/IconsFille/iconSvgJson.vue'
import IconSvgOdp from '@/components/Resource/IconsFille/IconSvgOdp.vue'
import IconSvgOds from '@/components/Resource/IconsFille/IconSvgOds.vue'
import IconSvgMov from '@/components/Resource/IconsFille/IconSvgMov.vue'
import IconSvgOdt from '@/components/Resource/IconsFille/IconSvgOdt.vue'
import IconSvgOgg from '@/components/Resource/IconsFille/IconSvgOgg.vue'
import IconSvgPdf from '@/components/Resource/IconsFille/IconSvgPdf.vue'
import IconSvgPng from '@/components/Resource/IconsFille/IconSvgPng.vue'
import IconSvgPpt from '@/components/Resource/IconsFille/IconSvgPpt.vue'
import IconSvgPptx from '@/components/Resource/IconsFille/IconSvgPptx.vue'
import IconSvgPsd from '@/components/Resource/IconsFille/IconSvgPsd.vue'
import IconSvgRar from '@/components/Resource/IconsFille/IconSvgRar.vue'
import IconSvgRtf from '@/components/Resource/IconsFille/IconSvgRtf.vue'
import IconSvgSvg from '@/components/Resource/IconsFille/IconSvgSvg.vue'
import IconSvgTiff from '@/components/Resource/IconsFille/IconSvgTiff.vue'
import IconSvgTxt from '@/components/Resource/IconsFille/IconSvgTxt.vue'
import IconSvgUrl from '@/components/Resource/IconsFille/IconSvgUrl.vue'
import IconSvgWav from '@/components/Resource/IconsFille/IconSvgWav.vue'
import IconSvgWebm from '@/components/Resource/IconsFille/IconSvgWebm.vue'
import IconSvgWebp from '@/components/Resource/IconsFille/IconSvgWebp.vue'
import IconSvgWmv from '@/components/Resource/IconsFille/IconSvgWmv.vue'
import iconSvgUnknown from '@/components/Resource/IconsFille/IconSvgUnknown.vue'

export default {
	components: {
		iconSvgXls,
		IconSvgXml,
		IconSvgZip,
		IconSvgXlsx,
		IconSvgMp3,
		IconSvgDoc,
		IconSvgJpg,
		IconSvg7z,
		IconSvgJpeg,
		IconSvgAv,
		IconSvgAvi,
		IconSvgBmp,
		IconSvgJs,
		IconSvgBzip,
		IconSvgCss,
		IconSvgCsv,
		IconSvgDocx,
		IconSvgFlac,
		iconSvgGif,
		IconSvgGz,
		IconSvgGzip,
		IconSvgHtm,
		IconSvgHtml,
		IconSvgIco,
		IconSvgMp4,
		IconSvgMpeg,
		IconSvgJson,
		IconSvgOdp,
		IconSvgOds,
		IconSvgMov,
		IconSvgOdt,
		IconSvgOgg,
		IconSvgPdf,
		IconSvgPng,
		IconSvgPpt,
		IconSvgPptx,
		IconSvgPsd,
		IconSvgRar,
		IconSvgRtf,
		IconSvgSvg,
		IconSvgTiff,
		IconSvgTxt,
		IconSvgUrl,
		IconSvgWav,
		IconSvgWebm,
		IconSvgWebp,
		IconSvgWmv,
		iconSvgUnknown,
	},
	props: {
		url: {
			type: String,
			default: '',
		},
		fileName: {
			type: String,
			default: '',
		},
		backgroundColor: {
			type: String,
			default: '#f3f3f6',
		},
		width: {
			type: String,
			default: '40',
		},
		height: {
			type: String,
			default: '45',
		},
	},
	data() {
		return {
			formats: [
				{
					format: '7z',
					icon: {
						component: IconSvg7z,
						props: {
							color: this.backgroundColor,
							width: this.width,
							height: this.height,
						},
					},
				},
				{
					format: 'av',
					icon: {
						component: IconSvgAv,
						props: {
							color: this.backgroundColor,
							width: this.width,
							height: this.height,
						},
					},
				},
				{
					format: 'avi',
					icon: {
						component: IconSvgAvi,
						props: {
							color: this.backgroundColor,
							width: this.width,
							height: this.height,
						},
					},
				},
				{
					format: 'bmp',
					icon: {
						component: IconSvgBmp,
						props: {
							color: this.backgroundColor,
							width: this.width,
							height: this.height,
						},
					},
				},
				{
					format: 'bzip',
					icon: {
						component: IconSvgBzip,
						props: {
							color: this.backgroundColor,
							width: this.width,
							height: this.height,
						},
					},
				},
				{
					format: 'css',
					icon: {
						component: IconSvgCss,
						props: {
							color: this.backgroundColor,
							width: this.width,
							height: this.height,
						},
					},
				},
				{
					format: 'csv',
					icon: {
						component: IconSvgCsv,
						props: {
							color: this.backgroundColor,
							width: this.width,
							height: this.height,
						},
					},
				},
				{
					format: 'doc',
					icon: {
						component: IconSvgDoc,
						props: {
							color: this.backgroundColor,
							width: this.width,
							height: this.height,
						},
					},
				},
				{
					format: 'docx',
					icon: {
						component: IconSvgDocx,
						props: {
							color: this.backgroundColor,
							width: this.width,
							height: this.height,
						},
					},
				},
				{
					format: 'flac',
					icon: {
						component: IconSvgFlac,
						props: {
							color: this.backgroundColor,
							width: this.width,
							height: this.height,
						},
					},
				},
				{
					format: 'gif',
					icon: {
						component: iconSvgGif,
						props: {
							color: this.backgroundColor,
							width: this.width,
							height: this.height,
						},
					},
				},
				{
					format: 'gz',
					icon: {
						component: IconSvgGz,
						props: {
							color: this.backgroundColor,
							width: this.width,
							height: this.height,
						},
					},
				},
				{
					format: 'gzip',
					icon: {
						component: IconSvgGzip,
						props: {
							color: this.backgroundColor,
							width: this.width,
							height: this.height,
						},
					},
				},
				{
					format: 'htm',
					icon: {
						component: IconSvgHtm,
						props: {
							color: this.backgroundColor,
							width: this.width,
							height: this.height,
						},
					},
				},
				{
					format: 'html',
					icon: {
						component: IconSvgHtml,
						props: {
							color: this.backgroundColor,
							width: this.width,
							height: this.height,
						},
					},
				},
				{
					format: 'ico',
					icon: {
						component: IconSvgIco,
						props: {
							color: this.backgroundColor,
							width: this.width,
							height: this.height,
						},
					},
				},
				{
					format: 'jpeg',
					icon: {
						component: IconSvgJpeg,
						props: {
							color: this.backgroundColor,
							width: this.width,
							height: this.height,
						},
					},
				},
				{
					format: 'jpg',
					icon: {
						component: IconSvgJpg,
						props: {
							color: this.backgroundColor,
							width: this.width,
							height: this.height,
						},
					},
				},
				{
					format: 'js',
					icon: {
						component: IconSvgJs,
						props: {
							color: this.backgroundColor,
							width: this.width,
							height: this.height,
						},
					},
				},
				{
					format: 'json',
					icon: {
						component: IconSvgJson,
						props: {
							color: this.backgroundColor,
							width: this.width,
							height: this.height,
						},
					},
				},
				{
					format: 'mov',
					icon: {
						component: IconSvgMov,
						props: {
							color: this.backgroundColor,
							width: this.width,
							height: this.height,
						},
					},
				},
				{
					format: 'mp3',
					icon: {
						component: IconSvgMp3,
						props: {
							color: this.backgroundColor,
							width: this.width,
							height: this.height,
						},
					},
				},
				{
					format: 'mp4',
					icon: {
						component: IconSvgMp4,
						props: {
							color: this.backgroundColor,
							width: this.width,
							height: this.height,
						},
					},
				},
				{
					format: 'mpeg',
					icon: {
						component: IconSvgMpeg,
						props: {
							color: this.backgroundColor,
							width: this.width,
							height: this.height,
						},
					},
				},
				{
					format: 'odp',
					icon: {
						component: IconSvgOdp,
						props: {
							color: this.backgroundColor,
							width: this.width,
							height: this.height,
						},
					},
				},
				{
					format: 'ods',
					icon: {
						component: IconSvgOds,
						props: {
							color: this.backgroundColor,
							width: this.width,
							height: this.height,
						},
					},
				},
				{
					format: 'odt',
					icon: {
						component: IconSvgOdt,
						props: {
							color: this.backgroundColor,
							width: this.width,
							height: this.height,
						},
					},
				},
				{
					format: 'ogg',
					icon: {
						component: IconSvgOgg,
						props: {
							color: this.backgroundColor,
							width: this.width,
							height: this.height,
						},
					},
				},
				{
					format: 'pdf',
					icon: {
						component: IconSvgPdf,
						props: {
							color: this.backgroundColor,
							width: this.width,
							height: this.height,
						},
					},
				},
				{
					format: 'png',
					icon: {
						component: IconSvgPng,
						props: {
							color: this.backgroundColor,
							width: this.width,
							height: this.height,
						},
					},
				},
				{
					format: 'ppt',
					icon: {
						component: IconSvgPpt,
						props: {
							color: this.backgroundColor,
							width: this.width,
							height: this.height,
						},
					},
				},
				{
					format: 'pptx',
					icon: {
						component: IconSvgPptx,
						props: {
							color: this.backgroundColor,
							width: this.width,
							height: this.height,
						},
					},
				},
				{
					format: 'psd',
					icon: {
						component: IconSvgPsd,
						props: {
							color: this.backgroundColor,
							width: this.width,
							height: this.height,
						},
					},
				},
				{
					format: 'rar',
					icon: {
						component: IconSvgRar,
						props: {
							color: this.backgroundColor,
							width: this.width,
							height: this.height,
						},
					},
				},
				{
					format: 'rtf',
					icon: {
						component: IconSvgRtf,
						props: {
							color: this.backgroundColor,
							width: this.width,
							height: this.height,
						},
					},
				},
				{
					format: 'svg',
					icon: {
						component: IconSvgSvg,
						props: {
							color: this.backgroundColor,
							width: this.width,
							height: this.height,
						},
					},
				},
				{
					format: 'tiff',
					icon: {
						component: IconSvgTiff,
						props: {
							color: this.backgroundColor,
							width: this.width,
							height: this.height,
						},
					},
				},
				{
					format: 'txt',
					icon: {
						component: IconSvgTxt,
						props: {
							color: this.backgroundColor,
							width: this.width,
							height: this.height,
						},
					},
				},
				{
					format: 'url',
					icon: {
						component: IconSvgUrl,
						props: {
							color: this.backgroundColor,
							width: this.width,
							height: this.height,
						},
					},
				},
				{
					format: 'wav',
					icon: {
						component: IconSvgWav,
						props: {
							color: this.backgroundColor,
							width: this.width,
							height: this.height,
						},
					},
				},
				{
					format: 'webm',
					icon: {
						component: IconSvgWebm,
						props: {
							color: this.backgroundColor,
							width: this.width,
							height: this.height,
						},
					},
				},
				{
					format: 'webp',
					icon: {
						component: IconSvgWebp,
						props: {
							color: this.backgroundColor,
							width: this.width,
							height: this.height,
						},
					},
				},
				{
					format: 'wmv',
					icon: {
						component: IconSvgWmv,
						props: {
							color: this.backgroundColor,
							width: this.width,
							height: this.height,
						},
					},
				},
				{
					format: 'xlsx',
					icon: {
						component: IconSvgXlsx,
						props: {
							color: this.backgroundColor,
							width: this.width,
							height: this.height,
						},
					},
				},
				{
					format: 'xml',
					icon: {
						component: IconSvgXml,
						props: {
							color: this.backgroundColor,
							width: this.width,
							height: this.height,
						},
					},
				},
				{
					format: 'xls',
					icon: {
						component: iconSvgXls,
						props: {
							color: this.backgroundColor,
							width: this.width,
							height: this.height,
						},
					},
				},
				{
					format: 'zip',
					icon: {
						component: IconSvgZip,
						props: {
							color: this.backgroundColor,
							width: this.width,
							height: this.height,
						},
					},
				},
			],
		}
	},
	computed: {
		iconImg() {
			const formatMatch = this.url.match(/(?<=\.)[^.]+$/)
			const fileNameFormatMatch = this.fileName.match(/(?<=\.)[^.]+$/)
			if (formatMatch) {
				const formatItem = this.formats.find((item) => item.format === formatMatch[0])
				if (formatItem && this.formats.some((item) => item.format === formatItem.format)) {
					return formatItem.icon
				} else if (
					formatMatch[0].length < 7 &&
					fileNameFormatMatch &&
					formatMatch[0] === fileNameFormatMatch[0]
				) {
					return {
						component: iconSvgUnknown,
						props: {
							color: this.backgroundColor,
							width: this.width,
							height: this.height,
						},
					}
				}
			}
			return {
				component: IconSvgUrl,
				props: {
					color: this.backgroundColor,
					width: this.width,
					height: this.height,
				},
			}
		},
	},
}
</script>

<style>
.file-format-icon {
	margin-right: 8px;
}
</style>
